<template>
  <div>
    <v-card>
      <v-card-title class="d-flex">
        <div style="width:100%;" class="d-flex align-center justify-space-between">
          <h3>Available Doctors</h3>
          <v-spacer></v-spacer>
          <div class="d-flex align-center">
            <v-icon class="mr-2" style="cursor:pointer" @click="type=null;search=null; getData()">mdi-close</v-icon>
            <v-autocomplete
              label="Ειδικότητα"
              color="rgb(0,170,221)"
              :items="types"
              item-text="option_value"
              item-value="option_key"
              v-model="type"
            ></v-autocomplete>
            <v-text-field class="ml-2" color="rgb(0,170,221)" label="Search..." v-model="search"></v-text-field>
            <v-btn rounded text @click="getData" class="text-capitalize ml-2">
              <p class="mb-0" style="color:rgb(0,170,221)">search</p>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table height="400" fixed-header :headers="headers" :items="data" :loading="loading">
          <template v-slot:item.firstName="{item}">{{item.firstName+' '+item.lastName}}</template>
          <template v-slot:item.isPublicDoctor="{item}">
            <v-icon>{{ !!item.isPublicDoctor ? 'mdi-check' : '' }}</v-icon>
          </template>
          <template
            v-slot:item.totalTimeOnCallMin=" { item }"
          >{{!!item.totalTimeOnCallMin ? item.totalTimeOnCallMin : '0' }}</template>
          <template
            v-slot:item.acceptedCallCount=" { item }"
          >{{item.acceptedCallCount + ' ('+percentage(item.acceptedCallCount, item.invitedCallCount)+'%)'}}</template>
          <template
            v-slot:item.declinedCallCount=" { item }"
          >{{item.declinedCallCount + ' ('+percentage(item.declinedCallCount, item.invitedCallCount)+'%)'}}</template>
          <template
            v-slot:item.cancelledCallCount=" { item }"
          >{{item.cancelledCallCount + ' ('+percentage(item.cancelledCallCount, item.invitedCallCount)+'%)'}}</template>
          <template
            v-slot:item.timedOutCallCount=" { item }"
          >{{item.timedOutCallCount + ' ('+percentage(item.timedOutCallCount, item.invitedCallCount)+'%)'}}</template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
export default {
  created() {
    axios
      .get(`${process.env.VUE_APP_BASE_URL}optionsList/doctorTypes/el`)
      .then(res => {
        console.log("xaxa", res);
        this.types = res.data;
      })
      .catch(err => {
        console.log(err);
      });
    this.getData();
  },

  data() {
    return {
      loading: false,
      search: null,
      types: [],
      type: null,
      headers: [
        {
          text: "Name",
          value: "firstName"
        },
        {
          text: "Email",
          value: "doctorEmail"
        },
        {
          text: "Mobile",
          value: "doctorMobile"
        },
        {
          text: "Doctor Type",
          value: "doctorTypeName"
        },
        {
          text: "Municipality",
          value: "currentMunicipalityName"
        },
        {
          text: "Prefecture",
          value: "currentPrefectureName"
        },
        {
          text: "Public Doctor",
          value: "isPublicDoctor"
        },
        {
          text: "Total Minutes",
          value: "totalTimeOnCallMin"
        },
        {
          text: "Times Invited",
          value: "invitedCallCount"
        },
        {
          text: "Calls Accepted",
          value: "acceptedCallCount"
        },
        {
          text: "Calls Declined",
          value: "declinedCallCount"
        },
        {
          text: "Calls got Cancelled",
          value: "cancelledCallCount"
        },
        {
          text: "Calls Timeout",
          value: "timedOutCallCount"
        }
      ],
      data: []
    };
  },

  methods: {
    getData() {
      this.loading = true;
      axios
        .get(`${process.env.VUE_APP_BASE_URL}admin/doctorsForVideoCall/list`, {
          params: {
            search: this.search,
            doctorType: this.type
          }
        })
        .then(res => {
          this.data = res.data.results;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    convertDate(date) {
      return moment(moment.utc(date).toDate())
        .local()
        .format("DD/MM");
    },
    percentage(num, per) {
      return Math.floor((num / per) * 100);
    }
  }
};
</script>